export const COUNTY_ADMIN = "CountyAdmin";
export const COUNTY_CLERK = "CountyClerk";
export const COUNTY_COMMISSIONER = "CountyCommissioner";
export const SOLICITOR = "Solicitor";
export const ASSESSOR = "Assessor";
export const ADMIN = "Admin";
export const AUTHORIZED_ATTORNEY = "AuthorizedAttorney";